import { Store, Module, ActionContext } from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Subject from '@/store/entities/portal/Subject';
import Ajax from '@/lib/ajaxBaseInfo';
import PageResult from '@/store/entities/page-result';

interface SubjectState extends ListState<Subject> {
    editSubject: Subject;
}

class SubjectModule extends ListModule<SubjectState, any, Subject>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Subject>(),
        loading: false,
        editSubject: new Subject(),
    }
    actions = {
        async getAll(context: ActionContext<SubjectState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/Subject/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Subject>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<SubjectState, any>, payload: any) {
            await Ajax.post('/Subject/Create', payload.data);
        },
        async update(context: ActionContext<SubjectState, any>, payload: any) {
            await Ajax.put('/Subject/Update', payload.data);
        },
        async delete(context: ActionContext<SubjectState, any>, payload: any) {
            await Ajax.delete('/Subject/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<SubjectState, any>, payload: any) {
            let reponse = await Ajax.get('/Subject/Get?Id=' + payload.data.id);
            context.state.editSubject = reponse.data.result as Subject; // set value for editing.
            return reponse.data.result as Subject;
        },
        async getByName(context: ActionContext<SubjectState, any>, payload: any) {
            let reponse = await Ajax.get(`/Subject/getByName?name=${payload.data}`);
            return reponse.data.result as Subject;
        },
        // Used in HTML editors which need to upload image function
        async uploadImage(context: ActionContext<SubjectState, any>, payload: any) {
            let reponse = await Ajax.post('/api/uploadImage?usage=PortalSubject', payload.data, { headers: { 'Content-Type': 'multipart/form-data' } });
            var result = reponse.data.result.location;
            return result;
        }
    };
    mutations = {
        setCurrentPage(state: SubjectState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SubjectState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const subjectModule = new SubjectModule();
export default subjectModule;